module.exports = __webpack_public_path__ + "img/gemischtertellerseitlich.1fa13068.jpg";